<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { initDeploymentWatcher } from './utils/deploymentWatcher'

export default {
  name: 'App',
  mounted() {
    this._cleanupDeploymentWatcher = initDeploymentWatcher()
  },
  beforeDestroy() {
    if (this._cleanupDeploymentWatcher) {
      this._cleanupDeploymentWatcher()
    }
  }
}
</script>
